import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { View } from 'foundations-components/components/View';
import { List } from 'foundations-components/transitional/components/List';
import { ListItem } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SortByRelevance = ({
  appearsIn
}) => {
  const [, setSortBy] = useSearchParam(FILTER_TYPES.SORT_BY);
  const handleSortByRelevanceChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value,
      isDropdown: true,
      key: 'sort-by-relevance',
      appearsIn
    });
    setSortBy(value);
  };
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(Dropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.topFilters.sortByRelevance.filterTitle"
      }),
      buttonUse: "transparent",
      children: /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: () => handleSortByRelevanceChange('RELEVANCE_DESCENDING'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.topFilters.sortByRelevance.RELEVANCE_DESCENDING"
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: () => handleSortByRelevanceChange('RELEVANCE_ASCENDING'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.topFilters.sortByRelevance.RELEVANCE_ASCENDING"
            })
          })
        })]
      })
    })
  });
};